import { keyBy } from "lodash-es";
import ReportCard from './ReportCard';
import { propPanelMixin } from '../../../../helpers';
const __script_base__ = {
  name: 'ReportCardList',
  mixins: [propPanelMixin],
  props: {
    showAddButton: {
      type: Boolean,
      default: true
    },
    showList: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ReportCard
  },
  methods: {
    removeReportKey(key) {
      this.modifyComp(c => {
        delete c.reports[key];
      });
    },
    handleReportChange(reportKey, value) {
      this.modifyComp(c => {
        c.reports[reportKey] = value;
      });
    },
    async addReport(key) {
      if (!key) return;
      await this.modifyComp(c => {
        c.reports = {
          ...c.reports,
          [key]: {
            value: ''
          }
        };
      });
      this.$emit('change');
      this.$nextTick(() => {
        var _this$$refs;
        (_this$$refs = this.$refs[`report${key}`]) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs[0]) === null || _this$$refs === void 0 || _this$$refs.triggerExpandable();
      });
    }
  },
  computed: {
    currentReports() {
      return this.comp.reports || {};
    },
    reportDict() {
      return keyBy(this.reportList, 'id');
    },
    reportList() {
      var _this$compMeta, _this$compMeta2;
      // 点击事件默认可以上报
      const externalReports = ((_this$compMeta = this.compMeta) === null || _this$compMeta === void 0 || (_this$compMeta = _this$compMeta.report) === null || _this$compMeta === void 0 ? void 0 : _this$compMeta.events) || [];
      const reportEvents = (externalReports.map(({
        id
      }) => id) || []).concat('click');
      const list = ((_this$compMeta2 = this.compMeta) === null || _this$compMeta2 === void 0 || (_this$compMeta2 = _this$compMeta2.events) === null || _this$compMeta2 === void 0 ? void 0 : _this$compMeta2.filter(({
        id
      }) => reportEvents.includes(id))) || [];

      // 补充eidPlaceholder
      list.forEach(item => {
        const report = externalReports.find(({
          id
        }) => id === item.id);
        if (report !== null && report !== void 0 && report.eidPlaceholder) {
          // eslint-disable-next-line no-param-reassign
          item.eidPlaceholder = report.eidPlaceholder;
        }
      });

      // 默认可以配置曝光事件
      return list.concat({
        name: '元素曝光',
        id: 'onview'
      });
    },
    validReportList() {
      return this.reportList.filter(item => !(item.id in this.currentReports));
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [!_vm.reportList.length && _vm.showAddButton ? _c("div", {
    staticClass: "ucd-eventPanel-noEventPlaceholder"
  }, [_vm._v("\n    此组件不支持添加上报\n  ")]) : _c("div", {
    staticClass: "ucd-eventPanel-eventCardList"
  }, [_vm.showList ? _c("div", _vm._l(_vm.currentReports, function (item, reportKey) {
    return _c("ReportCard", {
      key: reportKey,
      ref: "report" + reportKey,
      refInFor: true,
      attrs: {
        value: item,
        "report-meta": _vm.reportDict[reportKey],
        "report-key": reportKey
      },
      on: {
        change: function ($event) {
          return _vm.handleReportChange(reportKey, $event);
        },
        delete: function ($event) {
          return _vm.removeReportKey(reportKey);
        }
      }
    });
  }), 1) : _vm._e(), _vm._v(" "), _vm.showAddButton && _vm.validReportList.length ? _c("div", {
    staticClass: "ucd-eventCard-addBox",
    staticStyle: {
      display: "flex",
      "justify-content": "space-around"
    }
  }, [_c("a-dropdown", {
    attrs: {
      "overlay-class-name": "ucd-addDropdown",
      trigger: ["click"]
    }
  }, [_c("a-button", {
    staticClass: "ucd-eventCard-btn-add",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: function (e) {
        return e.preventDefault();
      }
    }
  }, [_vm._v("\n          添加上报\n        ")]), _vm._v(" "), _c("a-menu", {
    attrs: {
      slot: "overlay"
    },
    slot: "overlay"
  }, _vm._l(_vm.validReportList, function (report) {
    return _c("a-menu-item", {
      key: report.id,
      on: {
        click: function (e) {
          return _vm.addReport(report.id);
        }
      }
    }, [_vm._v("\n            " + _vm._s(report.name) + "\n          ")]);
  }), 1)], 1)], 1) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/EventPanel/ReportCardList/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);